var exports = {
  "a": "Box__pJ9Ks4",
};

module.exports = exports;
